/**
 * Tag <html> before first paint. Android WebView UA includes `wv`; that is
 * native and already sits below the status bar. Chrome / PWA does not.
 */
export function applySafeAreaPlatformClass (): void {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  const ua = navigator.userAgent || ''
  const isAndroid = /Android/i.test(ua)
  const isIOS = /iPhone|iPad|iPod/i.test(ua)
  const isMobile = isAndroid || isIOS || /Mobile/i.test(ua)
  if (isAndroid) root.classList.add('is-android')
  if (isIOS) root.classList.add('is-ios')
  if (isMobile) root.classList.add('is-mobile')
  if (isAndroid && /\bwv\b/.test(ua)) root.classList.add('is-native')
}

applySafeAreaPlatformClass()
